import { LoadStatusWithResponseDetail } from "../../../../../../../common/utils/async-status";
import { PageError } from "./types";

function getBase(state) {
  return state.nav.loadStatus;
}

function getLoadStatus(state) {
  return getBase(state).status;
}

function getPage(state) {
  return getBase(state).lastValidPage;
}

export function getCurrentPage(state) {
  return getPage(state).pages?.[0];
}

export function getCurrentPageCfi(state) {
  return getPage(state).pages?.[0]?.cfi;
}

export function isPageLoading(state) {
  return getLoadStatus(state) === LoadStatusWithResponseDetail.PENDING;
}

export function getPageError(state) {
  const error = getBase(state).errorInfo;
  if (!error) {
    return;
  }

  const { code, jigsawCode } = error;

  if (code === 404) {
    if (jigsawCode === "bookNotFound") {
      return PageError.BOOK_NOT_FOUND;
    }
    return PageError.PAGE_NOT_FOUND;
  } else if (code === 423) {
    return PageError.BOOK_REBUILDING;
  } else if (code === 403) {
    if (jigsawCode === "bookNotActivated") {
      return PageError.BOOK_NOT_ACTIVATED;
    }
    return PageError.ACCESS_DENIED;
  } else if (code === 401) {
    return PageError.LOGGED_OUT;
  } else if (code === 428) {
    return PageError.BOT_DETECTED;
  } else if (code === 444) {
    return PageError.BROWSER_NOT_SUPPORTED;
  } else if (code) {
    return PageError.UNKNOWN;
  }
}
